import { GET_QUEUES } from './mutation-types'
import relatorioFilasHttpService from '../_services/relatorioFilasHttpService'

export default {
  buscarFilas: async ({ commit }) => {
    try {
      const response = await relatorioFilasHttpService.getQueues()
      commit(GET_QUEUES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
